import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {ModelService} from '@cdk/services/model.service';
import {ParentGenericService} from './parent-generic.service';
import {DocumentoIAMetadata} from '@cdk/models';
import {Observable} from 'rxjs';
import {plainToClass} from 'class-transformer';
import {map} from 'rxjs/operators';

@Injectable()
export class DocumentoIAMetadataService extends ParentGenericService<DocumentoIAMetadata> {
    protected modelService: ModelService;
    protected http = inject(HttpClient);




    constructor() {
        const modelService = inject(ModelService);

        super(modelService, 'administrativo/documento_ia_metadata', DocumentoIAMetadata);

        this.modelService = modelService;
    }

    documentoClassificado(
        documentoId: number,
        nomeDocumentoPredito: string,
        populate: any = '[]'
    ): Observable<DocumentoIAMetadata> {
        const params = {};
        params['populate'] = populate;
        return this.modelService.post(
            `${this.path}/documento_classificado/${documentoId}/${nomeDocumentoPredito}`,
            {},
            new HttpParams({fromObject: params})
        ).pipe(
            map((response) => {
                response = plainToClass(this.clz, response);
                Object.keys(response).forEach(key => (response[key] === null) && delete response[key]);
                return Object.assign(new this.clz(), response);
            })
        );
    }
}
